import React from 'react';

export default function BrandLogo({
  size = 40,
  className = '',
  alt = 'ТОРГОСЛАВ',
  rounded = 'xl',
}) {
  const roundedClass = rounded === 'full' ? 'rounded-full' : rounded === 'xl' ? 'rounded-xl' : rounded === 'lg' ? 'rounded-lg' : '';
  return (
    <img
      src="/icon.png"
      alt={alt}
      width={size}
      height={size}
      className={`object-contain shrink-0 ${roundedClass} ${className}`.trim()}
    />
  );
}
